import _ from "lodash";
import { EditorState, ContentState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import moment from 'moment'
import { TARGET_AUDIENCES_MULTISELECT } from "components/create_workshop/constants";
const DATES_KEYS = ['end_date', 'end_time', 'start_date', 'start_time'];

export default class OnlineWorkshopService {
  setWorkshop = workshop => {
    let newWorkshop = {};
    _.keys(workshop).forEach(el => {
      if(DATES_KEYS.includes(el) && workshop[el]){
        _.assign(workshop, {[el]: moment(workshop[el])})
      }
      if (el === "target_audience") {
        let newtargetAudience = [];
        workshop.target_audience.forEach(target => {
          newtargetAudience.push({
            value: this.getTartgetByValue(target),
            label: target
          });
        });
        newWorkshop = _.assign({}, newWorkshop, {
          target_audience: newtargetAudience
        });
      }
      if (!(workshop[el] instanceof Array))
        if (workshop[el] !== null) {
          if (el === "description") {
            _.assign(newWorkshop, {
              description: workshop.description
            });
          } else _.assign(newWorkshop, { [el]: _.get(workshop, el) });
        }
    });
    const newCoupons = [];
    (workshop.coupons || []).forEach(el => {
      const coupon = {
        is_free: el.is_free,
        cost: el.cost,
        id: el.id,
        expiry_date: moment(el.expiry_date),
        code: el.code
      };
      newCoupons.push(coupon);
    });
    newWorkshop.coupons_attributes = newCoupons;
    if (workshop.more_info_url)
      _.assign(newWorkshop, {
        more_info: 1,
        file_name: workshop.more_info_file_name,
        file_size: workshop.more_info_file_size,
        key: 1
      });
    return newWorkshop;
  };

  // htmlToDrafJs = html => {
  //   const { contentBlocks, entityMap } = htmlToDraft(html || "");
  //   const contentState = ContentState.createFromBlockArray(
  //     contentBlocks,
  //     entityMap
  //   );
  //   return EditorState.createWithContent(contentState);
  // };

  setModules = modules => {
    if (modules.length === 0) return [];
    let newModules = [];
    modules.forEach((el, i) => {
      // this.htmlToDrafJs(_.assign("", el.description));
      let newModule = {
        id: el.id,
        title: el.title,
        details: el.description,
        module_type: el.module_type,
        questions_attributes: [],
        documents: [],
        openedQuestion: -1,
        attachments_attributes: [],
        position_index: el.position_index || el.id,
        is_hidden: el.is_hidden || false,
        key: i
      };

      let newQuestion = [];
      // const moduleItem = el;
      el.questions.forEach((el, i) => {
        // const qText =
        //   moduleItem.module_type == "quiz"
        //     ? el.text
        //     : this.htmlToDrafJs(el.text);
        let question = {
          text: el.text,
          correct: el.correct,
          id: el.id,
          attachments_attributes: [],
          documents: [],
          key: i
        };

        let attachments = [];
        el.attachments.forEach((el, i) => {

          attachments.push({
            file_name: el.document_file_name,
            file_size: el.document_file_size,
            key: i,
            id: el.id,
            document_from_url: el.document_url,
          });
        });
        _.assign(question, { attachments_attributes: attachments });
        newQuestion.push(question);
      });
      let attachments = [];
      el.attachments.forEach((el, i) => {
        attachments.push({
          id: el.id,
          file_name: el.document_file_name,
          file_size: el.document_file_size,
          file_url: el.document_url,
          key: i
        });
      });
      _.assign(newModule, { attachments_attributes: attachments });
      _.assign(newModule, { questions_attributes: newQuestion || null });
      newModules.push(newModule);
    });
    //debugger;

    return newModules;
  };

  setQuestion = question => {};

  getTartgetByValue = target => {
    let value = -1;
    TARGET_AUDIENCES_MULTISELECT.forEach(e => {
      if (e.label === target) value = e.value;
    });
    return value;
  };
}



// WEBPACK FOOTER //
// ./src/services/OnlineWorkshopService.js